import { rect, px } from '../../../pixel/canvas';
import { SLOT } from '../slots';
import type { Hull } from '../../types';

// Wolf — quadruped side profile, head on left, tail on right.
// Body y=18..52, x=4..54. Single-frame, no animation.
export const wolf: Hull = {
  id: 'wolf',
  name: 'Wolf',
  baseStats: { ferocity: 30, agility: 35, arcane: 5, resilience: 20, stealth: 15 },
  drawBody: (ctx, p) => {
    // Body trunk (shoulders to hips)
    rect(ctx, 18, 24, 28, 12, p.primary);
    // Belly shadow
    rect(ctx, 18, 33, 28, 3, p.shadow);
    // Back highlight
    rect(ctx, 20, 24, 24, 1, p.light);
    // Subtle accent stripe along flank
    rect(ctx, 22, 30, 20, 1, p.accent);

    // Head (rounded square on the left)
    rect(ctx, 8, 18, 12, 12, p.primary);
    rect(ctx, 8, 28, 12, 2, p.shadow);
    rect(ctx, 8, 18, 12, 1, p.light);

    // Snout (narrower, protrudes left)
    rect(ctx, 4, 22, 4, 6, p.primary);
    rect(ctx, 4, 26, 4, 2, p.shadow);
    // Nose
    px(ctx, 4, 24, p.dark);
    // Mouth line
    px(ctx, 5, 27, p.dark);

    // Ears (two upright tufts on top of head)
    rect(ctx, 10, 14, 2, 4, p.primary);
    rect(ctx, 16, 14, 2, 4, p.primary);
    // Inner ear shadow
    px(ctx, 10, 17, p.shadow);
    px(ctx, 16, 17, p.shadow);

    // Eye (single, side-profile)
    px(ctx, 14, 22, p.detail);

    // Front legs
    rect(ctx, 18, 36, 4, 14, p.primary);
    rect(ctx, 18, 36, 1, 14, p.shadow);
    rect(ctx, 18, 50, 4, 2, p.trim);  // paws
    rect(ctx, 24, 36, 4, 14, p.primary);
    rect(ctx, 24, 36, 1, 14, p.shadow);
    rect(ctx, 24, 50, 4, 2, p.trim);

    // Back legs
    rect(ctx, 36, 36, 4, 14, p.primary);
    rect(ctx, 36, 36, 1, 14, p.shadow);
    rect(ctx, 36, 50, 4, 2, p.trim);
    rect(ctx, 42, 36, 4, 14, p.primary);
    rect(ctx, 42, 36, 1, 14, p.shadow);
    rect(ctx, 42, 50, 4, 2, p.trim);

    // Tail base (extending rightward and slightly up)
    rect(ctx, 46, 26, 6, 4, p.primary);
    rect(ctx, 50, 24, 4, 4, p.primary);
    rect(ctx, 50, 24, 4, 1, p.light);
    rect(ctx, 46, 29, 6, 1, p.shadow);
  },
  mounts: {
    [SLOT.CRANIUM]: { anchor: { x: 14, y: 16 } },
    [SLOT.BACK]:    { anchor: { x: 30, y: 24 } },
    [SLOT.TAIL]:    { anchor: { x: 52, y: 26 } },
  },
};
